import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { FaTools } from 'react-icons/fa';
import useAuth from '../../dashboard/useAuth';
import Sidebar from '../../dashboard/sidebar';
import Navbar from '../../dashboard/navbar';
import axios from 'axios';

const Ajouter_groupe_processus = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Ajouter Groupe Processus";
        }
    }, [user_id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());

        // Envoyer toutes les données (titre et description) via une seule requête
        const response = await fetch(`${process.env.REACT_APP_HOTE}/ajouter-groupe-processus/${user_id}/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                titre_fr: data.titre_fr,
                description_fr: data.description_fr,
                titre_en: data.titre_en,
                description_en: data.description_en,
                ordre_fr: data.ordre_fr,
                ordre_en: data.ordre_en,
            }),
        });

        // Vérifier la réponse du serveur
        if (!response.ok) {
            setErrorMessage('Erreur lors de l\'enregistrement des données.');
        } else {
            setSuccessMessage('Les données ont été enregistrées avec succès.');
            navigate(`/Liste-groupe-processus`);
        }
    };

    const handleCancel = () => {
        window.location.reload(); // Redirection après 7 secondes
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("QCM")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h2 className="mb-1"><i className="fa fa-bookmark-o"></i> Ajouter Groupe Processus</h2>
                        <small>Admisnistration des Groupes processus qui correspondent aux cours ou chapitres</small>
                        <small id='hbreadcrumb' className='d-flex justify-content-end'>
                            <ol className="breadcrumb custom-breadcrumb">
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    <Link to={'/admin'}>Administration</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    <Link to={'/Liste-groupe-processus'}>Groupes Processus</Link>
                                </li>
                                <li className="breadcrumb-item custom-breadcrumb-item">
                                    Ajouter Groupe Processus
                                </li>
                            </ol>
                        </small>
                    </div>
                </div>

                <div className="col-lg-8 mx-auto m-1 p-1">
                    <div className="ibox ">
                        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                        {successMessage && <div className="alert alert-success">{successMessage}</div>}
                        <form className="m-t" role="form" onSubmit={handleSubmit}>
                            <div className="ibox-title">
                                <h5>Groupe Processus</h5>
                            </div>
                            <div className="ibox-content">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="ibox ">
                                            <div className="ibox-title justify-content p-1">
                                                <h4>Version Française</h4>
                                            </div>
                                            <div className="ibox-content">
                                                <div className="form-group">
                                                    <label>Titre<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="text" className="form-control mb-4" required name="titre_fr" />
                                                    <label>Description</label>
                                                    <input type="text" className="form-control" name="description_fr" />
                                                    <label>Ordre</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="ordre_fr"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="ibox ">
                                            <div className="ibox-title justify-content p-1">
                                                <h4>Version Anglaise</h4>
                                            </div>
                                            <div className="ibox-content">
                                                <div className="form-group">
                                                    <label>Title<span style={{ color: 'red' }}>*</span></label>
                                                    <input type="text" className="form-control mb-4" required name="titre_en" />
                                                    <label>Description</label>
                                                    <input type="text" className="form-control" name="description_en" />
                                                    <label>Order</label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="ordre_en"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ibox-footer d-flex justify-content-end">
                                <Link to='/Liste-groupe-processus' className="btn btn-default mr-2">Annuler</Link>
                                <button type="reset" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                <button type="submit" className="btn btn-success">Enregistrer</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ajouter_groupe_processus;
